import React from "react"
import { FaSpinner } from "react-icons/fa"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"

import { GenderMap } from "@fuse/utils/common"

import { SelectInput } from "@fuse/pages/signUp/steps/Gender"

interface AskGenderPopupProps {
  isLoading?: boolean
  onUpdateUserDetails: (v: Record<string, string>) => void
  onCloseDetailRowPopup: () => void
}

const AskGenderPopup: React.FC<AskGenderPopupProps> = ({
  isLoading,
  onUpdateUserDetails,
  onCloseDetailRowPopup,
}) => {
  const [selected, setSelected] = React.useState<string | null>(null)

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen w-full"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onCloseDetailRowPopup()
        }
      }}
    >
      <div className="w-[90%] max-w-lg bg-black backdrop-blur-md rounded-2xl p-10 space-y-6">
        <div className="text-left">
          <h2 className="text-white text-2xl font-semibold">Gender</h2>

          <p className="text-white mt-2 text-sm">
            Select your gender for personalized activity recommendations and
            connections.
          </p>
        </div>

        <div className="flex items-center gap-4 pb-8 flex-col">
          {Object.keys(GenderMap)?.map((item, index) => {
            return (
              <SelectInput
                key={index}
                label={GenderMap[item]}
                isSelected={selected === item}
                onClick={() => {
                  setSelected(item)
                }}
              />
            )
          })}
        </div>

        <Button
          className="w-full bg-white/20 text-white py-3 rounded-full font-medium transition"
          onClick={() => {
            onUpdateUserDetails({
              gender: selected,
            })
          }}
        >
          {isLoading ? (
            <FaSpinner className="animate-spin mr-2" size={22} />
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </div>
  )
}

export default AskGenderPopup
